import * as React from "react";
const SvgSignalCellularAlt2Bar = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M5 14h3v6H5v-6zm6-5h3v11h-3V9z",
  fill: "currentColor"
}));
export default SvgSignalCellularAlt2Bar;